__turbopack_context__.v({
  "className": "source_serif_4_58d78bd8-module__nJ_VlW__className",
  "variable": "source_serif_4_58d78bd8-module__nJ_VlW__variable",
});
